/**
 * Global Catalog Service — gestion del catalogo global del producto.
 *
 * Solo accesible para SUPER_ADMIN. Estos study_types y priorities tienen
 * `institution_id = NULL` y son visibles para todas las IPS, ademas de
 * usarse como base para aprovisionar a IPS individuales.
 */

import { get, post, patch, del } from '@/lib/api'
import { API_ROUTES } from '@/config/constants'
import type {
  InstitutionStudyType,
  InstitutionPriority,
} from '@/application/institution-insumos/institution-insumos.service'

export interface CreateGlobalStudyTypeInput {
  code: string
  name: string
  description?: string
  displayOrder?: number
}

export interface UpdateGlobalStudyTypeInput {
  name?: string
  description?: string | null
  displayOrder?: number
  isActive?: boolean
}

export interface CreateGlobalPriorityInput {
  code: string
  name: string
  color: string
  textColor?: string
  sortOrder: number
  isDefault?: boolean
}

export interface UpdateGlobalPriorityInput {
  name?: string
  color?: string
  textColor?: string
  sortOrder?: number
  isDefault?: boolean
  isActive?: boolean
}

// Study Types
export const listGlobalStudyTypes = (): Promise<{ studyTypes: InstitutionStudyType[] }> =>
  get(API_ROUTES.GLOBAL_CATALOG.STUDY_TYPES)

export const createGlobalStudyType = (
  data: CreateGlobalStudyTypeInput
): Promise<{ studyType: InstitutionStudyType }> =>
  post(API_ROUTES.GLOBAL_CATALOG.STUDY_TYPES, data)

export const updateGlobalStudyType = (
  id: string,
  data: UpdateGlobalStudyTypeInput
): Promise<{ studyType: InstitutionStudyType }> =>
  patch(API_ROUTES.GLOBAL_CATALOG.STUDY_TYPE_DETAIL(id), data)

export const deleteGlobalStudyType = (id: string): Promise<{ message: string }> =>
  del(API_ROUTES.GLOBAL_CATALOG.STUDY_TYPE_DETAIL(id))

// Priorities
export const listGlobalPriorities = (): Promise<{ priorities: InstitutionPriority[] }> =>
  get(API_ROUTES.GLOBAL_CATALOG.PRIORITIES)

export const createGlobalPriority = (
  data: CreateGlobalPriorityInput
): Promise<{ priority: InstitutionPriority }> =>
  post(API_ROUTES.GLOBAL_CATALOG.PRIORITIES, data)

export const updateGlobalPriority = (
  id: string,
  data: UpdateGlobalPriorityInput
): Promise<{ priority: InstitutionPriority }> =>
  patch(API_ROUTES.GLOBAL_CATALOG.PRIORITY_DETAIL(id), data)

export const deleteGlobalPriority = (id: string): Promise<{ message: string }> =>
  del(API_ROUTES.GLOBAL_CATALOG.PRIORITY_DETAIL(id))
